import * as tslib_1 from "tslib";
import { ImageStretchOptions_$type } from "./ImageStretchOptions";
import { ImageResourceType_$type } from "./ImageResourceType";
import { IgrCellInfo } from "./igr-cell-info";
import { ImageCellModel as ImageCellModel_internal } from "./ImageCellModel";
import { ensureEnum } from "igniteui-react-core";
/**
 * Backing information for an image cell in the grid.
*/
var IgrImageCellInfo = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrImageCellInfo, _super);
    function IgrImageCellInfo() {
        return _super.call(this) || this;
    }
    IgrImageCellInfo.prototype.createImplementation = function () {
        return new ImageCellModel_internal();
    };
    Object.defineProperty(IgrImageCellInfo.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrImageCellInfo.prototype, "imagePath", {
        /**
         * Sets or gets the resource path to use to get the image for the cell.
        */
        get: function () {
            return this.i.k4;
        },
        set: function (v) {
            this.i.k4 = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrImageCellInfo.prototype, "imageStretchOption", {
        /**
         * Sets or gets the image stretching behavior for the image.
        */
        get: function () {
            return this.i.kz;
        },
        set: function (v) {
            this.i.kz = ensureEnum(ImageStretchOptions_$type, v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrImageCellInfo.prototype, "imageResourceType", {
        /**
         * Sets or gets the image resource type. Indicates which type of resource should be fetched and how ImagePath should be interpreted.
        */
        get: function () {
            return this.i.kx;
        },
        set: function (v) {
            this.i.kx = ensureEnum(ImageResourceType_$type, v);
        },
        enumerable: true,
        configurable: true
    });
    return IgrImageCellInfo;
}(IgrCellInfo));
export { IgrImageCellInfo };
//# sourceMappingURL=igr-image-cell-info.js.map
